import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7eed92f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "filter-row",
  style: {"margin-bottom":"16px"}
}
const _hoisted_2 = {
  class: "selected-software",
  ref: "selectedNode"
}
const _hoisted_3 = { class: "cm-ui-mr5" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 1,
  class: "software-category-col"
}
const _hoisted_6 = {
  key: 0,
  class: "software-category"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-right" }, null, -1))
const _hoisted_9 = {
  key: 2,
  class: "software-item-col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["software-select-wrap", { popper: _ctx.popper }]),
    ref: "rootNode"
  }, [
    (!_ctx.popper)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_input, {
            size: "small",
            modelValue: _ctx.searchParams.searchKey,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParams.searchKey) = $event)),
            modelModifiers: { trim: true },
            placeholder: _ctx.displayPlaceholder,
            "suffix-icon": "el-icon-search"
          }, null, 8, ["modelValue", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["selected-software-wrap", { focus: _ctx.popperShow, disabled: _ctx.disabled }]),
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.popperShow = !_ctx.popperShow), ["stop"]))
    }, [
      (_ctx.checkIds.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "clear-all",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.checkIds = []), ["stop"]))
          }, [
            _createVNode(_component_CmSvgIcon, {
              name: "views/dashboard/_components/software-select/_images/close-fill",
              monochrome: "",
              color: "var(--el-text-color-primary)",
              size: 18
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkIds, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_tag, {
            type: "info",
            closable: "",
            size: "small",
            onClose: _withModifiers(($event: any) => (_ctx.checkIds.splice(index, 1)), ["stop"]),
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.allSoftwareList.find(v => v.soft_id === item)?.soft_name), 1)
            ]),
            _: 2
          }, 1032, ["onClose"]))
        }), 128)),
        (_ctx.popper)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "embed-search el-input__inner",
              placeholder: _ctx.checkIds.length ? '' : _ctx.placeholder,
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParams.searchKey) = $event)),
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.popperShow = true), ["stop"]))
            }, null, 8, _hoisted_4)), [
              [
                _vModelText,
                _ctx.searchParams.searchKey,
                void 0,
                { trim: true }
              ]
            ])
          : _createCommentVNode("", true),
        (!_ctx.popper && !_ctx.checkIds.length)
          ? (_openBlock(), _createBlock(_component_EmptyData, {
              key: 1,
              text: _ctx.displayPlaceholder,
              height: 100
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ], 512)
    ], 2),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["software-panel-wrap", `placement-${_ctx.placement}`])
    }, [
      (!_ctx.softwareShowTree.length)
        ? (_openBlock(), _createBlock(_component_EmptyData, {
            key: 0,
            style: {"margin":"20px 0"},
            height: "100%"
          }))
        : _createCommentVNode("", true),
      (_ctx.softwareShowTree.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.allAble)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_el_checkbox, {
                    style: {"width":"100%"},
                    indeterminate: _ctx.allIndeterminate,
                    "model-value": !!_ctx.checkIds.length,
                    onChange: _ctx.checkAll
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.selectAllLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["indeterminate", "model-value", "onChange"])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.softwareShowTree, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["software-category", { active: _ctx.activeGroupIndex === index }]),
                key: index,
                onClick: ($event: any) => (_ctx.activeGroupIndex = index)
              }, [
                _createVNode(_component_el_checkbox, {
                  indeterminate: !!(_ctx.getGroupChecked(item) && _ctx.getGroupChecked(item) !== item.software_list.length),
                  "model-value": _ctx.getGroupChecked(item) === item.software_list.length,
                  onChange: ($event: any) => (_ctx.checkGroup($event, item))
                }, null, 8, ["indeterminate", "model-value", "onChange"]),
                _createElementVNode("span", null, _toDisplayString(item.group_name), 1),
                _hoisted_8
              ], 10, _hoisted_7))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.softwareShowTree.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.softwareShowTree[_ctx.activeGroupIndex]?.software_list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "software-item",
                key: index
              }, [
                _createVNode(_component_el_checkbox, {
                  "model-value": _ctx.getSoftwareIsChecked(item),
                  onChange: ($event: any) => (_ctx.checkSoftware($event, item))
                }, null, 8, ["model-value", "onChange"]),
                _createElementVNode("span", null, _toDisplayString(item.soft_name), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2)), [
      [_directive_loading, _ctx.isLoading],
      [_vShow, _ctx.popperShow || !_ctx.popper]
    ])
  ], 2)), [
    [_directive_loading, _ctx.isLoading]
  ])
}